import { useState } from "react";
import { faqs } from "../../../mocks/gossip";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
      <div className="grid gap-10 lg:grid-cols-3">
        <div>
          <p className="inline-flex items-center gap-2 text-sm font-semibold tracking-wide text-[#b4372a]">
            <span className="h-px w-6 bg-[#b4372a]"></span>常见问题
          </p>
          <h2 className="mt-3 font-serif-sc text-3xl font-black leading-snug text-[#2a2320] md:text-4xl">
            关于吃瓜门，你可能想问
          </h2>
          <p className="mt-4 leading-relaxed text-[#5a5049]">
            我们对图谱、关系判断与信息甄别给出简明回答。核心提示：关系可以梳理，真伪仍需核实。
          </p>
        </div>

        <div className="lg:col-span-2">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className="mb-3 rounded-lg border border-[#eadccb] bg-white"
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="font-serif-sc text-base font-bold text-[#2a2320] md:text-lg">{f.q}</span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition ${
                      isOpen ? "bg-[#b4372a] text-white" : "bg-[#f7e4d6] text-[#98301f]"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true"></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="border-t border-[#f0e4d4] px-5 py-4 text-sm leading-relaxed text-[#5a5049]">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}